import { render, staticRenderFns } from "./PartnerLogo.vue?vue&type=template&id=72f94fb8&scoped=true&"
import script from "./PartnerLogo.vue?vue&type=script&lang=js&"
export * from "./PartnerLogo.vue?vue&type=script&lang=js&"
import style0 from "./PartnerLogo.vue?vue&type=style&index=0&id=72f94fb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f94fb8",
  null
  
)

export default component.exports